import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_mt-1" }
const _hoisted_2 = { class: "_pl-6 _pr-6" }
const _hoisted_3 = { class: "_mt-3" }
const _hoisted_4 = { class: "_mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_localize = _resolveComponent("localize")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("fieldset", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.Resources.Account.TwoFactorAuthenticationEmailSecurityCodeLeadParagraph), 1 /* TEXT */),
      _createVNode(_component_text_field, {
        modelValue: $data.authenticationData,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.authenticationData) = $event)),
        name: "authenticationData",
        "display-name": _ctx.Resources.Account.SecurityCodeFieldLabel,
        onKeydown: _withKeys(_withModifiers($options.submit, ["prevent","stop"]), ["enter"]),
        "data-qa": "login-form-two-factor-step:SecurityCodeField"
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "onKeydown"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "gfu-btn gfu-btn--accent gfu-btn--block gfu-btn--soft gfu-btn__text",
          onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.submit && $options.submit(...args)), ["stop","prevent"])),
          "data-qa": "login-form-two-factor-step:LoginButton"
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Resources.Account.LogInButton), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.Account.TwoFactorAuthenticationEmailSecurityCodeResendParagraphPart1
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              "format-key": "0",
              href: "",
              class: "gfu-link gfu-link--accent",
              onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.resendCode && $options.resendCode(...args)), ["prevent","stop"])),
              "data-qa": "login-form-two-factor-step:ResendCodeLink"
            }, _toDisplayString(_ctx.Resources.Account.TwoFactorAuthenticationEmailSecurityCodeResendParagraphPart2), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.Account.TwoFactorLoginStepCancelParagraphPart1
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              "format-key": "0",
              href: "",
              class: "gfu-link gfu-link--accent",
              onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.cancel && $options.cancel(...args)), ["prevent","stop"]))
            }, _toDisplayString(_ctx.Resources.Account.TwoFactorLoginStepCancelParagraphPart2), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ])
    ]),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}